import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { curProductAtom, qrCodeUrlAtom, loadingAtom, seatsAtom } from '@/store';
import { getDisplayPrice, getPayChannels } from '@/utils/vip';
import { channelsMap, isTeamSubscription } from '@/constants';
import { SubscriptionPeriod } from '@meitu/subscribe-core';

/**
 * 支付信息 hook，用于计算当前商品的价格、支付渠道等信息
 * 被 scan-ui 和 pay-qr-modal 共同使用
 */
export const usePaymentInfo = () => {
  const [curProduct] = useAtom(curProductAtom);
  const [qrCodeUrl] = useAtom(qrCodeUrlAtom);
  const [loading] = useAtom(loadingAtom);
  const [seats] = useAtom(seatsAtom);

  const paymentInfo = useMemo(() => {
    let durationValue = 0;
    const subPeriodDuration = curProduct?.subPeriodDuration || 0;
    switch (curProduct?.subPeriod) {
      case SubscriptionPeriod.Day:
        durationValue = Math.ceil(subPeriodDuration / 30);
        break;
      case SubscriptionPeriod.PerMonth:
        durationValue = subPeriodDuration * 1;
        break;
      case SubscriptionPeriod.PerQuarter:
        durationValue = subPeriodDuration * 3;
        break;
      case SubscriptionPeriod.PerYear:
        durationValue = subPeriodDuration * 12;
        break;
      default:
        break;
    }
    const unitPriceValue = +(
      (getDisplayPrice(curProduct).payPrice || 0) / (durationValue || 1)
    ).toFixed(2);
    const totalPriceValue = isTeamSubscription
      ? +(getDisplayPrice(curProduct).payPrice * seats).toFixed(2)
      : getDisplayPrice(curProduct).payPrice;
    const payChannelsValue: string[] = getPayChannels(curProduct) || [];
    const payChannelsTextValue = payChannelsValue
      .map((item: string) => channelsMap[item] || '')
      .filter(Boolean)
      .join('/');

    return {
      unitPrice: unitPriceValue,
      totalPrice: totalPriceValue,
      duration: durationValue,
      payChannels: payChannelsValue,
      payChannelsText: payChannelsTextValue,
    };
  }, [curProduct, seats]);

  return {
    curProduct,
    qrCodeUrl,
    loading,
    seats,
    ...paymentInfo,
  };
};
